
<template>
  <!-- fixed-top-->
<div>
<div class="banner d-flex w-100 h-100 p-5 mx-auto flex-column ">
    <div class="container">
        <div class="row">
            <div class="col-md-6 texto-banner text-white">
                <h1>Realiza tu <span> cambio</span> desde 
                    la <span>comodidad</span> de tu <span>casa</span>
                </h1>
                <br>
                <h3>Trabajamos con todos los <span>bancos</span></h3>
                <div class="d-flex pt-3">
                    <img class="flex-shrink-0 me-2" src="@/assets/img/calidad1.svg" alt="" width="50">
                    <p class="pb-3 mb-0 small lh-sm p-3">Registrado en: <br>
                    <span> SUPERINTENDENCIA <br>
                    DE BANCA, SEGUROS Y AFP</span>
                    </p>
                </div>
           </div>
           <div class="col-md-6 calculadora" id="">
               <div class="col-sm-7 mb-2 me-auto texto-cambio">
                   <p class="text-center text-white">Tipo de cambio en <span> Lima - Perú </span></p>
                   <p class="text-center text-white">Compra USD: {{CambioCompra}} Venta USD: {{CambioVenta}}</p>
               </div>

               <div class="col-sm-7 d-flex mb-2 me-auto cambio">
                   <p class="flex-shrink-0 small me-2 mb-0">
                       {{monedaEnviar}} <small class="texto-grande">{{simboloMonedaEnviar}}</small></p>

                  <div class="mb-0 small  me-auto">
                        Enviar {{descMonedaEnviar}} <br>
                        <input type="text" class="v-cambio"  id="ValorEnviar" v-model="ValorEnviar"  @keyup="CambiarMonedaEnviar" @keypress="soloFloat" minlength="4" maxlength="10" size="3" :disabled="disabled">  
                       
                  </div>
               </div>
               <div class="col-sm-7 mb-2 me-auto ">
                   <img class="flechas-cambio" @click="cambiarMoneda" src="@/assets/img/flechas-cambio.svg" width="30" alt="">
               </div>
               
               <div class="col-sm-7 d-flex me-auto cambio">
                   <p class="flex-shrink-0 small me-2 mb-0">
                       {{monedaRecibir}} <small class="texto-grande">{{simboloMonedaRecibir}}</small></p>
                  <div class="mb-0 small  me-auto">
                        Recibir {{descMonedaRecibir}} <br>
                        <input type="text" class="v-cambio"  id="ValorRecibir" v-model="ValorRecibir"  @keyup="CambiarMonedaRecibir" @keypress="soloFloat" minlength="4" maxlength="10" size="3" :disabled="disabled">  
                    
                  </div>
               </div>
               <div class="col-sm-7 mb-2 me-auto">
                   <p class="text-center text-white">Ahorro estimado: S/ 80.00</p>
               </div> 
               <br>
               <div class="col-sm-7 mb-2 me-auto">
                   <p class="text-center text-white"><small class="texto-medium"> Contáctenos al: {{numeroContacto}}</small></p>
               </div> 

          </div>
      </div>
  </div>       
</div>
<div class="col-md-12 logos">
            <div class="container">
                <section class="customer-logos slider">
                   <div class="slide"><img src="@/assets/img/bcp.png"></div>
                   <div class="slide"><img src="@/assets/img/interbank.png"></div>
                   <div class="slide"><img src="@/assets/img/pichincha.png"></div>
                   <div class="slide"><img src="@/assets/img/banfin.png"></div>
                   <div class="slide"><img src="@/assets/img/scotiabank.png"></div>
                   <div class="slide"><img src="@/assets/img/bbva.png"></div>
                   <div class="slide"><img src="@/assets/img/bcp.png"></div>
                   <div class="slide"><img src="@/assets/img/interbank.png"></div>
                   <div class="slide"><img src="@/assets/img/pichincha.png"></div>
                   <div class="slide"><img src="@/assets/img/banfin.png"></div>
                   <div class="slide"><img src="@/assets/img/scotiabank.png"></div>
                   <div class="slide"><img src="@/assets/img/bbva.png"></div>
                </section>


             </div>
          </div>
</div>
  <!-- ////////////////////////////////////////////////////////////////////////////-->
</template>

<script>
import auth from '@/services/auth'
import helpers from '@/services/helpers'

export default {
  name: "Header",
  data() {
    return {
      ValorEnviar:"",
      referenciaDolar: "",
      ValorRecibir:"",
      CambioCompra:"",
      CambioVenta:"",
      tipoCompra:true,
      monedaEnviar:"USD",
      simboloMonedaEnviar:"$",
      descMonedaEnviar:"Dólares",
      monedaRecibir:"PEN",
      simboloMonedaRecibir:"S/",
      descMonedaRecibir:"Soles",
      numeroContacto:"",
      disabled: true,
    };
  },
   mounted() {
    
  },
 
  methods:{
    async cerrarSesion(){
      if(await auth.logout()){
        this.$router.push("/auth-login").catch(err => {});
      }
    },
    getNombreUsuario(){
      return this.$store.getters.getAuthUserName;
    },
    getAreaActual(){
      return this.$store.getters.getAuthUser('areaActualTexto');
    },
    getPermisoActual(){
      return this.$store.getters.getAuthUser('permisoActualTexto');
    },
    soloFloat($event){
        helpers.soloFloat($event);
    },
    CambiarMonedaRecibir(){
        this.ValorEnviar=helpers.convertirEnviar(this.ValorRecibir,this.referenciaDolar,this.tipoCompra);
    },
    CambiarMonedaEnviar(){
        this.ValorRecibir=helpers.convertirRecibir(this.ValorEnviar,this.referenciaDolar,this.tipoCompra);
    },
    

    cambiarMoneda(){
        if(this.tipoCompra==true){
           this.tipoCompra=false;
           this.monedaEnviar="PEN";
           this.simboloMonedaEnviar="S/";
           this.descMonedaEnviar="Soles";
           this.monedaRecibir="USD";
           this.simboloMonedaRecibir="$";
           this.descMonedaRecibir="Dólares";
           this.referenciaDolar=this.$store.getters.getTipoCambio('venta');
           this.CambiarMonedaEnviar();
        }
        else{
           this.tipoCompra=true;
           this.monedaEnviar="USD";
           this.simboloMonedaEnviar="$";
           this.descMonedaEnviar="Dólares";
           this.monedaRecibir="PEN";
           this.simboloMonedaRecibir="S/";
           this.descMonedaRecibir="Soles";
           this.referenciaDolar=this.$store.getters.getTipoCambio('compra');
           this.CambiarMonedaEnviar();
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/Header.vue